'use es6';

import { Map as ImmutableMap } from 'immutable';
import { FETCH_CONTENT_SCHEMA_SUCCEEDED } from 'ContentEditorUI/redux/actions/actionTypes';
const contentGroupReducer = (state = ImmutableMap(), {
  type,
  response
}) => {
  switch (type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      return state.merge({
        itemLayoutId: response.content_group.itemLayoutId,
        itemTemplatePath: response.content_group.itemTemplatePath
      });
    default:
      return state;
  }
};
export default contentGroupReducer;